import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bf-auth" }
const _hoisted_2 = { class: "bf-auth__form-wrap" }
const _hoisted_3 = { class: "bf-auth__card" }
const _hoisted_4 = { class: "bf-field" }
const _hoisted_5 = { class: "bf-field" }
const _hoisted_6 = { class: "bf-auth__signup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"bf-auth__brand\"><div class=\"bf-auth__brand-inner\"><img class=\"bf-auth__brand-logo\" src=\"/img/brand/bindfy_logo_new_white.png\" alt=\"Bindfy\"><h2>Defina uma nova senha.</h2><p> Escolha uma senha forte para manter sua conta e suas integrações protegidas. </p></div><div class=\"bf-auth__blob bf-auth__blob--1\"></div><div class=\"bf-auth__blob bf-auth__blob--2\"></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("img", {
          class: "bf-auth__logo-mobile",
          src: "/img/brand/bindfy_logo_new_purple.png",
          alt: "Bindfy"
        }, null, -1)),
        _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "bf-auth__title" }, "Redefinir senha", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "bf-auth__desc" }, "Digite e confirme sua nova senha", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("label", null, "Nova senha", -1)),
            _createVNode(_component_TextInput, {
              label: 'Digite a sua nova senha',
              type: 'password',
              modelValue: _ctx.passwordResetForm.password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwordResetForm.password) = $event)),
              "error-messages": 
                _ctx.v$.password.$errors
                  ? _ctx.v$.password.$errors[0]?.$message
                  : undefined
              
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("label", null, "Confirme a nova senha", -1)),
            _createVNode(_component_TextInput, {
              label: 'Digite a sua nova senha novamente',
              type: 'password',
              modelValue: _ctx.passwordResetForm.confirmationPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordResetForm.confirmationPassword) = $event)),
              "error-messages": 
                _ctx.v$.confirmationPassword.$errors
                  ? _ctx.v$.confirmationPassword.$errors[0]?.$message
                  : undefined
              
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _createVNode(_component_PrimaryButton, {
            "is-loading": _ctx.isLoading,
            label: "Redefinir senha"
          }, null, 8, ["is-loading"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/autenticar/acessar",
              class: "bf-link"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" ← Voltar para login ", -1)
              ]))]),
              _: 1
            })
          ])
        ], 32)
      ])
    ])
  ]))
}